export default `
precision highp float;
varying vec2 vUv;

uniform float aspect;
uniform float aperture;
uniform vec3 color;

void main() {
	vec2 uv = vUv;
	vec2 centerOffset = uv - vec2(0.5, 0.5);
	centerOffset.x *= aspect;
	float distanceFromCenter = 1.0 - length(centerOffset);

	float alpha = 0.9 - smoothstep(aperture - 0.1, aperture, distanceFromCenter);
	gl_FragColor = vec4(color, alpha);
}`;